import { Button, Card, Group, Text } from '@mantine/core';
import { IconAdjustments } from '@tabler/icons-react';
import { SearchInput } from '@/components/ui/inputs';

interface Props {
  appliedCount: number;
  matchCount: number;
  totalCount: number;
  entityLabel: string;
  onOpen: () => void;
  onClear: () => void;
  showSearch?: boolean;
  search?: string;
  onSearchChange?: (value: string) => void;
}

export function FiltersBar({
  appliedCount, matchCount, totalCount, entityLabel,
  onOpen, onClear, showSearch, search = '', onSearchChange,
}: Props) {
  return (
    <Card withBorder radius="md" padding="md">
      <Group justify="space-between" wrap="wrap">
        <Group gap="sm">
          <Text fw={600}>2. Filters</Text>
          {showSearch && (
            <SearchInput
              placeholder="Search…"
              value={search}
              onChange={(value) => onSearchChange?.(value)}
              size="sm"
              w={240}
            />
          )}
          <Button variant="outline" leftSection={<IconAdjustments size={16} />} onClick={onOpen}>
            Filters{appliedCount > 0 ? ` (${appliedCount})` : ''}
          </Button>
          {appliedCount > 0 && (
            <Button variant="subtle" onClick={onClear}>Clear Filters</Button>
          )}
        </Group>
        <Text size="sm" c="dimmed">
          {matchCount} of {totalCount} {entityLabel} match
        </Text>
      </Group>
    </Card>
  );
}